<template>
    <title>{{ informations.title }}</title>
    <link rel="icon" type="image/jpg" :href="'https://admin.asso-refuge.fr/images/' + informations.logo" />
<div class="fixedtoi">
    <header >
      <i class="fas fa-envelope"></i> assoccc91@gmail.com &nbsp;&nbsp;&nbsp;&nbsp;

    </header>

    <nav class="navbar navbar-expand-lg navbar-light bg-light " >
       <div class="navbar-container container-fluid">

        <a class="navbar-brand" href="/">
          <img
            :src="'https://admin.asso-refuge.fr/images/' + informations.logo"
            :alt="informations.title"
            width="75px"
          />
          {{ informations.title }}
        </a>

        <!-- Ici on applique la classe 'show' selon isCollapsed -->
        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]" id="navbarNav">
          <div class="navbar-nav">
            <router-link class="nav-link" :to="{ path: '/' }" @click="toggleNavbar">Notre association</router-link>

            <template v-for="page in pages" :key="page.id">
              <router-link
                class="nav-link"
                :to="'/' + (page.path_website ? page.path_website : page.path)"
                @click="toggleNavbar"
              >
                {{ page.name }}
              </router-link>
            </template>

            <router-link
              class="nav-link"
              :to="{ path: '/', hash: '#actuID' }"
              @click="toggleNavbar"
            >
              Evénements
            </router-link>
          </div>
        </div>

        <!-- Le bouton déclenche toggleNavbar -->
        <button
          class="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          :aria-expanded="!isCollapsed"
          aria-label="Toggle navigation"
          @click="toggleNavbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
</div>
    <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      pages: [],
      informations: {},
      isCollapsed: true, // Le menu est fermé au départ
    };
  },
  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getPages/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        const pagesModifiees = data.map((page) => {
          const newPage = { ...page };
          if (newPage.path === "services") newPage.path = "comment_adopter";
          if (newPage.path_website === "services") newPage.path_website = "comment_adopter";
          if (newPage.name === "Nos services") newPage.name = "Comment adopter";
          return newPage;
        });
        this.pages = pagesModifiees;
      })
      .catch((error) => {
        console.error("Erreur requête pages:", error.message);
      });

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        this.informations = data[0] || {};
      })
      .catch((error) => {
        console.error("Erreur requête infos:", error.message);
      });
  },
  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style src="../assets/css/refonte.css"></style>
